import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonSecondaryAccentExtraLarge } from "../generic/common/ButtonSecondaryAccentExtraLarge";
import { Icon } from "../generic/icon/Icon";
import { TextLoca } from "../generic/text/TextLoca";
export var DoghouseTopRewards = React.memo(function (_a) {
    var rewards = _a.rewards, onClick = _a.onClick;
    var rewardElements = rewards.map(function (icon, key) {
        return React.createElement(Icon, { icon: icon, styleId: IdStyles.IconLarge, key: key });
    });
    return (React.createElement("div", { className: IdStyles.DogTreatRewardsContainer + " rewards-container" },
        React.createElement(TextLoca, { id: IdLoca.topRewards, className: IdStyles.TextBoldAccent }),
        React.createElement("div", { className: "top-rewards w100" }, rewardElements),
        React.createElement(ButtonSecondaryAccentExtraLarge, { onClick: onClick },
            React.createElement(TextLoca, { id: IdLoca.showAll, className: IdStyles.TextButtonDefault }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/DoghouseTopRewards.tsx
// module id = 923
// module chunks = 3